import {


    // GET FINAL DECISIONS
    GET_FINAL_DECISIONS,
    GET_FINAL_DECISIONS_SUCCESS,
    GET_FINAL_DECISIONS_FAIL,

    GET_RETEST_CANDIDATES,
    GET_RETEST_CANDIDATES_SUCCESS,
    GET_RETEST_CANDIDATES_FAIL,




} from "./actionTypes";




// GET FINAL DECISIONS
export const getFinalDecisions = (payload) => ({
    type: GET_FINAL_DECISIONS,
    payload,
});
export const getFinalDecisionsSuccess = (data) => ({
    type: GET_FINAL_DECISIONS_SUCCESS,
    payload: data,
});
export const getFinalDecisionsFail = (error) => ({
    type: GET_FINAL_DECISIONS_FAIL,
    payload: error,
});


// --- NOUVELLES ACTIONS POUR LE RATTRAPAGE ---

export const getRetestCandidates = (payload) => ({
    type: GET_RETEST_CANDIDATES,
    payload: payload,
});

export const getRetestCandidatesSuccess = (response) => ({
    type: GET_RETEST_CANDIDATES_SUCCESS,
    payload: response,
});

export const getRetestCandidatesFail = (error) => ({
    type: GET_RETEST_CANDIDATES_FAIL,
    payload: error,
});